export default __webpack_public_path__ + "static/media/Garmin_logo_2006.730f7947.svg";